/**
 * @generated SignedSource<<4596985f8e14a1297c0283adf7d4490c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type SetAnswerInSingleChoiceFreeTextQuestionInput = {
  answerOptions: ReadonlyArray<PotentialAnalysisFreeTextAnswerOptionInput>;
  clientMutationId?: string | null;
  givenAnswer: PotentialAnalysisSelectedWithFreetextGivenAnswerInput;
  learnPotentialAnalysisId: string;
  questionId: string;
  questionText: string;
};
export type PotentialAnalysisFreeTextAnswerOptionInput = {
  answerOptionId: number;
  isFreeText: boolean;
  text: string;
};
export type PotentialAnalysisSelectedWithFreetextGivenAnswerInput = {
  answerOptionId: number;
  text?: string | null;
};
export type checkboxQuestion_SetAnswerInSingleChoiceFreeTextQuestionMutation$variables = {
  input: SetAnswerInSingleChoiceFreeTextQuestionInput;
};
export type checkboxQuestion_SetAnswerInSingleChoiceFreeTextQuestionMutation$data = {
  readonly PotentialAnalysis: {
    readonly setAnswerInSingleChoiceFreeTextQuestion: {
      readonly question: {
        readonly givenAnswer: {
          readonly answerOptionId: number;
          readonly freeText: string | null;
        } | null;
        readonly id: string;
      } | null;
    } | null;
  };
};
export type checkboxQuestion_SetAnswerInSingleChoiceFreeTextQuestionMutation = {
  response: checkboxQuestion_SetAnswerInSingleChoiceFreeTextQuestionMutation$data;
  variables: checkboxQuestion_SetAnswerInSingleChoiceFreeTextQuestionMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "PotentialAnalysisMutations",
    "kind": "LinkedField",
    "name": "PotentialAnalysis",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
          }
        ],
        "concreteType": "SetAnswerInSingleChoiceFreeTextQuestionPayload",
        "kind": "LinkedField",
        "name": "setAnswerInSingleChoiceFreeTextQuestion",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "PotentialAnalysisSingleChoiceFreetextQuestion",
            "kind": "LinkedField",
            "name": "question",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "PotentialAnalysisSelectedWithFreetextGivenAnswer",
                "kind": "LinkedField",
                "name": "givenAnswer",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "answerOptionId",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "freeText",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "checkboxQuestion_SetAnswerInSingleChoiceFreeTextQuestionMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "checkboxQuestion_SetAnswerInSingleChoiceFreeTextQuestionMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "18a4a73b372bb8d5a4b390dae2f37416",
    "id": null,
    "metadata": {},
    "name": "checkboxQuestion_SetAnswerInSingleChoiceFreeTextQuestionMutation",
    "operationKind": "mutation",
    "text": "mutation checkboxQuestion_SetAnswerInSingleChoiceFreeTextQuestionMutation(\n  $input: SetAnswerInSingleChoiceFreeTextQuestionInput!\n) {\n  PotentialAnalysis {\n    setAnswerInSingleChoiceFreeTextQuestion(input: $input) {\n      question {\n        id\n        givenAnswer {\n          answerOptionId\n          freeText\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "3b629080c4916ed05ceab9ba633d884d";

export default node;
